<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeStart, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeStart.$touch()"
              @blur="$v.dateRangeStart.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeEnd, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeEnd.$touch()"
              @blur="$v.dateRangeEnd.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeEnd = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'current'"
          @itemChange="(e) => (selectedCurrent = e)"
          :label="'Cari'"
      >
      </search-select>
    </div>
    <div class="col-lg-3">
      <v-select
        v-model="salesPersonCode"
        label="Plasiyer"
        filled
        solo
        clearable
        dense
        :items="salesPersonList"
        :item-text="item => item.name"
        :item-value="item => item.code"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-text-field
          v-model="documentNumber"
          label="Belge No"
          filled
          solo
          dense
          clearable
      >

      </v-text-field>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="rateType"
          label="Oran Tipi"
          :items="[1]"
          filled
          solo
          dense
          clearable
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="reportDbName"
          label="Şirket Adı"
          filled
          solo
          dense
          clearable
          :items="companyList"
          item-text="name"
          item-value="name"
          @click:clear="reportDbName = 0"
      >

      </v-select>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport"><v-icon left>mdi-filter</v-icon>FİLTRELE</v-btn>
    </div>
  </div>

</template>

<script>

import {formattedDate} from "@/momentHelper";
import { mapActions,mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMessages } from "@/validationMessages";
import {showProcessErrorMessage} from "@/state/alertHelpers";
import SearchSelect from "@/components/searchSelect.vue";


export default {
  name: "FaturaKarlilik",
  components: {SearchSelect},
  props:{
    reportType:{
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.fetchSalesPersonList({
      params: {

      },
      body: {

      }
    });
    this.fetchCompanyList({
      params: {

      },
      body: {

      }
    });
  },
  computed:{
    ...mapState("current",["salesPersonList"]),
    ...mapState("company",["companyList"]),
    ...mapState("auth",["user"])
  },
  data() {
    return {
      dateRangeStart: null,
      dateRangeEnd: null,
      salesPersonCode: null,
      currentCode: null,
      reportDbName: null,
      rateType: 1,
      documentNumber: null,
      filterRequestObject: {},
      currentSearchText: "",
      currentSearchLoading: false,
      currentSearchResult: [],
      searchCurrentTimeout: null,
      selectedCurrent: null
    }
  },
  validations: {
    dateRangeStart: {
      required,
    },
    dateRangeEnd: {
      required,
    },
  },
  methods:{
    ...mapActions("current", ["fetchSalesPersonList","fetchCurrentList"]),
    ...mapActions("company", ["fetchCompanyList"]),
    formattedDate,
    validationMessages,
    async _fetchCurrentList(){
     this.currentSearchResult = await this.fetchCurrentList({
        params:{
          userId : this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2  ? true : false) && {salesPersonCode: this.user.SalesPersonCode },
          ...(this.currentSearchText == "" || this.currentSearchText == null  ? false : true) && {searchText: this.currentSearchText }
        },
        body: {

        },
       loading: false
      });
     this.currentSearchLoading = false;
    },
    filterReport(){
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.filterRequestObject = {
          StartDate: this.dateRangeStart,
          FinishDate: this.dateRangeEnd,
          DocumentNumber: this.documentNumber,
          SalesPersonCode: this.salesPersonCode,
          CurrentCode: this.selectedCurrent,
          BranchCode: null,
          RateType: 1,
          ReportDbName: this.reportDbName,
        };
        this.$emit("reportFilterChange",this.filterRequestObject);
      }
      else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })

    }
  },
  watch: {
    currentSearchText:function(newVal){
      if(newVal && (newVal.length > 2))
      {
        this.currentSearchResult = [];
        if(this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
        this.currentSearchLoading = true
        this.searchCurrentTimeout = setTimeout(() => {

          this._fetchCurrentList();

        },2000);
      }
    }
  }
}
</script>

<style scoped>

</style>